const env = {
    'is_development': (window.X_IS_DEVELOPMENT === "true" || process.env.REACT_APP_IS_DEVELOPMENT === "true" || false),
    'api': (window.X_API_URL || process.env.REACT_APP_API_URL),
    'organization_name': (window.X_ORGANIZATION_NAME || process.env.REACT_APP_ORGANIZATION_NAME),
    'colors': (JSON.parse(window.X_COLORS || process.env.REACT_APP_COLORS))
};

export default env;